<div class="hexagon {{hexClass}}" [style.width.px]="hexSize" [style.height.px]="hexSize">
  <div class="hexagon__content">
    <ng-content></ng-content>
  </div>
  <svg viewBox="0 0 512 512" [class.with-fill]="hexWithFill" [style.stroke-width.px]="hexStrokeWidth">
    <use [attr.xlink:href]="'assets/icons/hexagon.svg#svg1'"></use>
  </svg>
</div>
